export { default } from './text';
